
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";




export function NotFound(){

    const {t} = useTranslation()
    const navigate= useNavigate()

    function handleClick(){
        navigate('/fr/maps');
    }
    return(
        <>
        <section className="page-container">
            <h1 className="page-title">{t("page_not_found.title")}</h1>
            <div className='section-container'>
                <p>{t('page_not_found.description')}</p>
            </div>
            <br/>
            <button onClick={()=>handleClick}>{t('page_not_found.back_to_home')}</button>
        </section>
        </>
    )

}